import { motion } from 'motion/react'
import { SVGProps } from 'react'

interface AnimatedIconProps extends SVGProps<SVGSVGElement> {
	isActive?: boolean
}

export default function AnimatedHomeIcon({ isActive, ...props }: AnimatedIconProps) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<motion.path
				key="filled"
				d="M19.5715 7.3914L14.261 3.73221C12.9215 2.75593 11.088 2.75593 9.7485 3.73221L4.4285 7.3914C3.2125 8.27381 2.5 9.67253 2.5 11.1651V19.0599C2.5 19.7827 2.8135 20.4868 3.355 21.0031C3.887 21.51 4.5995 21.7822 5.35 21.7822H8.2C8.7225 21.7822 9.15 21.3598 9.15 20.8435V16.4596C9.15 15.9433 9.5775 15.5208 10.1 15.5208H13.9C14.4225 15.5208 14.85 15.9433 14.85 16.4596V20.8435C14.85 21.3598 15.2775 21.7822 15.8 21.7822H18.65C19.4005 21.7822 20.113 21.51 20.645 21.0031C21.1865 20.4961 21.5 19.7921 21.5 19.0599V11.1651C21.5 9.67253 20.7875 8.27381 19.5715 7.3914Z"
				fill="none"
				stroke="var(--tint-primary)"
				strokeWidth="2.1"
				strokeLinecap="round"
				strokeLinejoin="round"
				animate={{
					fill: isActive ? 'var(--tint-primary)' : 'rgba(0, 0, 0, 0)',
					stroke: isActive ? 'rgba(0, 0, 0, 0)' : 'var(--tint-primary)',
				}}
				transition={{
					duration: 0.2,
				}}
			/>
		</svg>
	)
}
